import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { u, IMG } from "@/lib/site";

export default function Gallery() {
    return (
        <>
            <Seo
                title="Gallery | ISHAAN WORLDLINK LLP"
                description="Photography from the ISHAAN WORLDLINK LLP timber yard and processing operations in Gandhidham — currently being curated."
            />

            {/* HERO */}
            <section className="relative flex min-h-[50svh] items-end overflow-hidden bg-ink" data-testid="gallery-hero">
                <img
                    src={u(IMG.mill, 2000)}
                    alt="Timber stacks inside a lumber warehouse"
                    className="absolute inset-0 h-full w-full object-cover opacity-60"
                    fetchPriority="high"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/55 to-ink/30" />
                <div className="relative mx-auto w-full max-w-7xl px-4 pb-16 pt-44 sm:px-6 lg:px-8">
                    <Reveal y={16}>
                        <Eyebrow dark>Gallery</Eyebrow>
                        <h1 className="mt-4 font-display text-4xl font-semibold leading-[1.02] tracking-tight text-cream sm:text-5xl lg:text-6xl">
                            GALLERY
                        </h1>
                    </Reveal>
                </div>
            </section>

            {/* EMPTY STATE — intentionally minimal */}
            <section className="bg-cream py-20 sm:py-28" data-testid="gallery-empty">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <Reveal>
                        <div className="border border-line bg-white px-8 py-16 text-center sm:px-16 sm:py-20">
                            <p className="inline-flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.3em] text-teak">
                                <span className="h-1.5 w-1.5 rounded-full bg-gold" />
                                Coming Soon — Our Teak Processing Journey
                            </p>
                            <h2 className="mx-auto mt-5 max-w-xl font-display text-3xl font-semibold leading-tight tracking-tight text-ink sm:text-4xl">
                                Our gallery is being curated
                            </h2>
                            <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-mutedw sm:text-base">
                                This space will soon feature timber photographs, processing and
                                saw-mill imagery, product photography, facility views and our
                                team — straight from Gandhidham.
                            </p>
                            <Link
                                to="/contact"
                                data-testid="gallery-enquire-btn"
                                className="group mt-9 inline-flex items-center gap-2 bg-ink px-7 py-4 text-[13px] font-semibold uppercase tracking-[0.14em] text-cream transition-colors duration-300 hover:bg-teak"
                            >
                                Enquire Now
                                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                            </Link>
                        </div>
                    </Reveal>
                </div>
            </section>
        </>
    );
}
